import { useEffect, useState } from 'react';
import { Fetch } from '../helpers/fetchWrapper';
import { useCancellablePromise } from '../helpers/promiseHandler';

const STATUS = {
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};

const projectService = {
  _url: process.env.REACT_APP_PROJECTS_API_URL,
  GetAllProjects(fetch) {
    const [projects, setProjects] = useState({
      sessions: [],
      totalItems: 0,
    });
    const { cancellablePromise } = useCancellablePromise();
    const [status, setStatus] = useState(STATUS.LOADING);
    useEffect(() => {
      setStatus(STATUS.LOADING);
      cancellablePromise(this.getProjects())
        .then(res => {
          setProjects(() => res);
          setStatus(STATUS.SUCCESS);
        })
        .catch(() => setStatus(STATUS.ERROR));
    }, [fetch]);

    return {
      _loading: status === STATUS.LOADING,
      _error: status === STATUS.ERROR,
      _data: projects,
    };
  },
  GetAllProjectsSessions(searchQuery, fetch) {
    const [projectsSessions, setProjectsSessions] = useState({
      sessions: [],
      totalItems: 0,
    });
    const { cancellablePromise } = useCancellablePromise();
    const [status, setStatus] = useState(STATUS.LOADING);
    useEffect(() => {
      setStatus(STATUS.LOADING);
      cancellablePromise(this.getProjectSessions(searchQuery))
        .then(res => {
          setProjectsSessions(() => res);
          setStatus(STATUS.SUCCESS);
        })
        .catch(() => setStatus(STATUS.ERROR));
    }, [fetch]);

    return {
      _loading: status === STATUS.LOADING,
      _error: status === STATUS.ERROR,
      _data: projectsSessions,
    };
  },

  GetProjectSessions(searchQuery, fetch) {
    const [projectsSessions, setProjectsSessions] = useState({
      sessions: [],
      totalItems: 0,
    });
    const { cancellablePromise } = useCancellablePromise();
    const [status, setStatus] = useState(STATUS.LOADING);
    useEffect(() => {
      setStatus(STATUS.LOADING);
      cancellablePromise(this.getProjectSessions(searchQuery))
        .then(res => {
          setProjectsSessions(() => res);
          setStatus(STATUS.SUCCESS);
        })
        .catch(() => setStatus(STATUS.ERROR));
    }, [fetch]);

    return {
      _loading: status === STATUS.LOADING,
      _error: status === STATUS.ERROR,
      _data: projectsSessions,
    };
  },

  getProjects() {
    return Fetch.get(`${this._url}/list`);
  },
  async createProject(payload) {
    return Fetch.post(`${this._url}/create`, payload);
  },
  async updateProject(payload) {
    return await Fetch.put(`${this._url}/update`, payload);
  },
  async deleteProject(project_id) {
    return await Fetch.delete(`${this._url}/delete?project_id=${project_id}`);
  },
  async createProjectSessions(payload) {
    return await Fetch.post(`${this._url}/session/add`, payload);
  },
  async getProjectSessions(project_id) {
    return await Fetch.get(`${this._url}/session/list?project_id=${project_id}`);
  },
  async deleteProjectSession(payload) {
    return await Fetch.delete(`${this._url}/session/delete`, payload);
  },
};

export default projectService;
